export class AboutUs {
    constructor(target) {
		this._target = document.getElementById(target)
        this._target.setAttribute('hidden', '')
		this._target.innerHTML = `<div class="aboutUsContent">

        <div class="aboutUsHero">
            <p class="aboutUsEyebrow">Über uns</p>
            <h1>Wir lieben unser Viertel!</h1>
            <p class="aboutUsLede">Schnell, selbstorganisiert, fair und unabhängig – die Lieferalternative aus der Nachbarschaft.</p>
        </div>

        <h2>Von der Idee zum alternativen Lieferservice</h2>
        <p>Unsere Vision von einem eigenen, unabhängigen Lieferservice ist während der Corona-Krise entstanden. Gastronominnen und Gastronomen im Viertel waren wie viele Einzelhändler und Kulturschaffende von echten Existenzängsten betroffen. Wir haben uns zusammengefunden und gesagt: Das können wir besser – und so ist der Viertel-Lieferservice online gegangen.</p>
        <p>Dafür brauchte es gute Ideen, einen Plan und ein Team aus unterschiedlichen, idealistischen Menschen mit ganz unterschiedlichen Fähigkeiten: Organisation, Programmierung, Webdesign, Troubleshooting, Kommunikation und Finanzbuchhaltung.</p>

        <div class="aboutUsQuotes">
            <div class="aboutUsQuoteCard">
                <p class="aboutUsQuoteLabel">Du:</p>
                <strong>„Es muss aber auch schnell gehen und darf nicht zu viel kosten …"</strong>
            </div>
            <div class="aboutUsQuoteCard aboutUsQuoteCard--us">
                <p class="aboutUsQuoteLabel">Wir vom Viertel-Lieferservice:</p>
                <strong>„Wir sind für dich da und beliefern dich mit heißen und kalten Speisen und Getränken!"</strong>
                <strong>„Und das zu fairen Preisen, die dir und den Gastronomen Spaß machen!"</strong>
            </div>
        </div>

        <h2>Warum wir günstiger sind</h2>
        <ul class="aboutUsReasons" role="list">
            <li>Wir sind selbstorganisiert – ohne Konzern, der mitverdienen will</li>
            <li>Alle unsere Restaurants und Läden sind direkt im Viertel</li>
            <li>Wir liefern vorwiegend zweirädrig – mit Fahrrad, E-Bike oder Motorroller</li>
            <li>Kurze Wege bedeuten: Das Essen kommt heiß, schnell und frisch an</li>
            <li>Wir wollen uns nicht auf Kosten der Gastronomen oder unserer Kund:innen bereichern</li>
        </ul>

        <h2>Eine Familie von Anwendungen</h2>
        <p>Was als einfacher Online-Shop begann, ist heute ein ganzes Netzwerk eigens entwickelter Anwendungen. Jede deckt einen Teil des Ablaufs ab – von der Speisekarte bis zur Haustür – und alle greifen nahtlos ineinander.</p>

        <div class="aboutUsApps">
            <article class="aboutUsAppCard">
                <span class="aboutUsAppStep">1</span>
                <h3>Produktverwaltung</h3>
                <p>Läden pflegen hier ihre Speisekarten, Kategorien, Preise und Varianten – zentral und in Echtzeit.</p>
            </article>
            <article class="aboutUsAppCard">
                <span class="aboutUsAppStep">2</span>
                <h3>Store-Management</h3>
                <p>Stammdaten, Öffnungszeiten und Lieferkonditionen aller teilnehmenden Restaurants und Läden an einem Ort.</p>
            </article>
            <article class="aboutUsAppCard">
                <span class="aboutUsAppStep">3</span>
                <h3>Onlineshop</h3>
                <p>Der Shop, in dem Kund:innen stöbern, bestellen und bezahlen – schlank, schnell und werbefrei.</p>
            </article>
            <article class="aboutUsAppCard">
                <span class="aboutUsAppStep">4</span>
                <h3>Bestellbearbeitung</h3>
                <p>Diese App: Eingehende Bestellungen annehmen, vorbereiten und für die Abholung bereitstellen.</p>
            </article>
            <article class="aboutUsAppCard">
                <span class="aboutUsAppStep">5</span>
                <h3>Lieferung</h3>
                <p>Fahrer:innen mit Fahrrad, E-Bike oder Motorroller bringen die Bestellung zuverlässig zu den Kund:innen nach Hause.</p>
            </article>
        </div>
        <p class="aboutUsTechNote">Alle Anwendungen sind eigenständig entwickelt und laufen auf modernen, browserbasierten Webtechnologien – ganz ohne Zwischenhändler oder Fremdplattformen.</p>

        <h2>Wir wachsen langsam, aber stetig</h2>
        <p>Probieren geht über Studieren – und so haben wir klein angefangen. Aus einem einfachen Online-Shop ist inzwischen eine intelligente Softwarelandschaft geworden, die optimale Lieferrouten berechnet und Bestellungen automatisch an die richtigen Stellen verteilt.</p>
        <p>Und natürlich darf auch ein korrektes, transparentes Finanzwesen im Hintergrund nicht fehlen. Fertig ist so ein System nie ganz – aber mit der Zeit wird es immer besser. Und genau daran arbeiten wir.</p>

        <div class="aboutUsNotice">
            <h2>Ein Hinweis in eigener Sache</h2>
            <p>Der zugehörige Kundenshop ist aktuell ein <strong>Demoshop</strong>. Kund:innen können sich dort bereits umschauen und alle Funktionen live erleben – echte Bestellungen sind aber noch nicht möglich.</p>
        </div>

        </div>`
	}

	setVisible = visible => visible ? this._target.removeAttribute('hidden') : this._target.setAttribute('hidden', '')
}
